import { MyOrganizationCommunity } from './MyOrganizationCommunity'
import MyOrganizationCommunityPopupProvider from './Providers/MyOrganizationCommunityPopupProvider'

export const MyOrganizationCommunityContainer = () => {
  return (
    <MyOrganizationCommunityPopupProvider>
      <MyOrganizationCommunity />
    </MyOrganizationCommunityPopupProvider>
  )
}
